import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { EXPERIMENT_ROUTES, OLD_DASHBOARD_ROUTES } from "@src/routes/routes";

export const DashboardRoutes: RouteObject[] = [
  {
    path: `${OLD_DASHBOARD_ROUTES.Dashboard}/*`,
    element: <Navigate to={EXPERIMENT_ROUTES.Experiments} />,
  },
];
